import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CourseCard from "@/components/CourseCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const [courses, setCourses] = useState([]);
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const activeCat = params.get("cat") || "Todos";

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats(["Todos", ...(Array.isArray(data) ? data : [])])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const p = {};
    if (activeCat !== "Todos") p.category = activeCat;
    if (q) p.q = q;
    api.get("/courses", { params: p }).then(({ data }) => setCourses(Array.isArray(data) ? data : [])).catch(() => {}).finally(() => setLoading(false));
  }, [activeCat, q]);

  const setCat = (c) => {
    if (c === "Todos") setParams({}); else setParams({ cat: c });
  };

  return (
    <div className="App">
      <Navbar />
      <section className="pt-28 pb-12 max-w-7xl mx-auto px-6">
        <span className="font-mono text-xs uppercase tracking-widest text-[#00E5FF]">// Catálogo</span>
        <h1 className="font-heading font-bold text-4xl md:text-6xl tracking-tighter mt-3 mb-8">Todos los cursos</h1>

        <div className="relative max-w-md mb-8">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#525560]" />
          <Input data-testid="catalog-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cursos..."
            className="pl-10 bg-[#13141C] border-white/10 rounded-md focus:border-[#00E5FF] focus-visible:ring-1 focus-visible:ring-[#00E5FF] text-white placeholder:text-[#525560]" />
        </div>

        <div className="flex flex-wrap gap-3 mb-12">
          {cats.map((c) => (
            <button key={c} data-testid={`filter-${c}`} onClick={() => setCat(c)}
              className={`font-mono text-xs uppercase tracking-wider px-4 py-2 rounded-md border transition-all ${activeCat === c ? "bg-[#00E5FF] text-black border-[#00E5FF]" : "bg-transparent text-[#8A8D98] border-white/10 hover:border-white/30"}`}>
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="py-24 flex justify-center"><div className="w-10 h-10 border-2 border-[#00E5FF] border-t-transparent rounded-full animate-spin" /></div>
        ) : courses.length === 0 ? (
          <p className="font-body text-[#8A8D98] py-16 text-center">No se encontraron cursos.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((c) => <CourseCard key={c.id} course={c} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
